import { AxiosResponse } from "axios"
import api from "./Api"

export const getWellnessLectureDetailByWellnessLectureId = (wellnessLectureId: string): Promise<AxiosResponse<IWellnessLectureDetailWebResponseV2, any>> => {
    return api.get(`/wellness-lecture/web/v2/${wellnessLectureId}`)
}

export const getMyWellnessLectureListByDateAndTeacherId = (startDate: string, endDate: string, teacherId: string): Promise<AxiosResponse<Array<IMyWellnessLectureListByDateAndTeacherIdResponseV2>, any>> => {
    return api.get(`/wellness-lecture/teacher/web/v2?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&teacherId=${teacherId}`);
}